<template>
    <v-container fluid class="pa-0">
        <v-row class="pl-2 pr-6 note">
            <v-col
                v-if="isNote"
                :class="
                    onlyNote ? 'col-12 col-md-12 text-center' : 'col-5 offset-1'
                "
            >
                <span class="title">Nota:</span>
                <span class="response pl-4">{{ points }}</span>
            </v-col>
            <v-col
                v-if="isPercentage"
                :class="
                    onlyPercentage ? 'col-12 col-md-12 text-center' : 'col-6'
                "
            >
                <span class="title">Logro:</span>
                <span class="response pl-4"
                    >{{ calculatePercentage(percentage) }}%</span
                >
            </v-col>
        </v-row>
        <v-row v-if="showAnswers" no-gutters class="pl-6 pr-4 pb-2 pt-2 legend">
            <v-col
                ><v-icon color="correct">mdi-checkbox-marked</v-icon>
                <span>Correctas: </span>
                <span class="ml-1">{{ corrects }}</span></v-col
            >
            <v-col
                ><v-icon color="incorrect">mdi-checkbox-marked</v-icon>
                <span>Incorrectas: </span>
                <span class="ml-1">{{ incorrects }}</span></v-col
            >
            <v-col
                ><v-icon color="skipped">mdi-checkbox-marked</v-icon>
                <span>Omitidas: </span>
                <span class="ml-1">{{ skippeds }}</span></v-col
            >
        </v-row>
        <hr />

        <v-tabs
                v-if="showAnswers"
                v-model="tab"
                background-color="transparent"
                color="basil"
                grow
                >
                <v-tab
                href="#tab-1"
                >
                    Respuestas
                </v-tab>
                <v-tab
                    v-if="(attachFiles || enterText) "
                    href="#tab-2"
                >
                    Texto / Archivos
                </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">

                <v-tab-item value="tab-1">
                    
                    <v-row no-gutters class="pa-5">
                        <div class="mt-3" style="width: 100%;">
                                <v-row
                                    class="container-question"
                                    v-for="(question, x) in questions"
                                    :key="x + 1"
                                    align="center"
                                    no-gutters
                                    :class="question.class"

                                >
                                    <template v-if="question.options && question.options.length > 0">
                                        <v-col cols="2">
                                            <button class="btn-question">
                                                <v-icon>{{ parseInt(x + 1) }}</v-icon>
                                            </button>
                                        </v-col>
                                        <v-col
                                            cols="2"
                                            v-for="(o, j) in question.options"
                                            :key="j"
                                            class="pl-1"
                                        >
                                            <button v-if="!getIsPreBasicAndLinkEmbebed"
                                            class="answer" :class="o.class">
                                                <v-icon>{{ o.letter }}</v-icon>
                                            </button>
                                            <button v-if="getIsPreBasicAndLinkEmbebed" 
                                            class="answer" :class="[o.class, `answer${o.letter}`]">
                                    
                                                <v-icon>{{ o.letter }}</v-icon>
                                            </button>
                                            <v-icon
                                                class="icon-indicator"
                                                color="correct"
                                                v-if="o.mode === 'correct'"
                                                >mdi-check</v-icon
                                            >
                                            <v-icon
                                                class="icon-indicator"
                                                color="incorrect"
                                                v-if="o.mode === 'incorrect'"
                                                >mdi-close</v-icon
                                            >
                                            <!--                        <v-icon-->
                                            <!--                            class="icon-indicator"-->
                                            <!--                            color="correct"-->
                                            <!--                            v-if="o.mode === 'skipped'"-->
                                            <!--                            >mdi-check</v-icon-->
                                            <!--                        >-->
                                        </v-col>
                                    </template>

                                    <template v-else>
                                            <v-col cols="2">
                                            <button class="btn-question">
                                                <v-icon>{{ parseInt(x + 1) }}</v-icon>
                                            </button>
                                            </v-col>
                                                        <v-col>
                                                            <v-expansion-panels
                                                                flat
                                                                elevation-0
                                                                class="panels"
                                                            >
                                                                <v-expansion-panel
                                                                elevation-0
                                                                >
                                                                <v-expansion-panel-header
                                                                    :class="
                                                                        (question.text && question.text.length > 0) || (question.files && question.files.length > 0)
                                                                            ? 'active'
                                                                            : 'inactive'"
                                                                >
                                                                    Responder
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content
                                                                >
                                                                        <quillEditor
                                                                        v-if="question.enterText"
                                                                        class="lesson-detail__quill"
                                                                        :content="question.text"
                                                                        :options="editorOptionByQuestion"
                                                                        :disabled="true"
                                                                        />
                                                                        <v-file-input
                                                                            disabled
                                                                            v-if="question.attachFiles"
                                                                            v-model="question.files"
                                                                            placeholder="Subir archivos"
                                                                            label="Archivos"
                                                                            multiple
                                                                            prepend-icon="mdi-paperclip"
                                                                            small-chips
                                                                            truncate-length="15"
                                                                            
                                                                        >
                                                                            <template v-slot:selection="{ text }">
                                                                            <v-chip
                                                                                small
                                                                                label
                                                                                color="primary"
                                                                            >
                                                                                {{ text }}
                                                                            </v-chip>
                                                                            </template>
                                                                        </v-file-input>
                                                                

                                                                </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                    </v-col>
                                    </template>
                                
                                </v-row>
                        </div>
                    </v-row>


                </v-tab-item>

                <v-tab-item
                    value="tab-2"
                    v-if="attachFiles || enterText"
                >

                     <quillEditor
                        v-if="enterText"
                        class="lesson-detail__quill"
                        :content="textRubrica"
                        :options="editorOption"
                        :disabled="true"
                        @change="onEditorChange($event)"

                    />
                    <template>
                    <v-file-input
                        disabled
                        
                        v-if="attachFiles"
                        v-model="files"

                        placeholder="Subir archivos"
                        label="Archivos"
                        multiple
                        prepend-icon="mdi-paperclip"
                        small-chips
                        truncate-length="25"
                    >
                        <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                        </template>
                    </v-file-input>
                    </template>


                </v-tab-item>

        </v-tabs-items>

    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
    name: "EvaluationResults",
    data() {
        return {
            files: [],
            textRubrica: '',
            attachFiles:false,
            enterText:false,
            editorOption: {
                readOnly: false,
                modules: {
                    toolbar: [
                            ]
                },
                placeholder: ''
            },
            editorOptionByQuestion: {
                readOnly: true,
                modules: {
                    toolbar: [
                            ]
                       
                },
                placeholder: ''
            },

            tab: null,
            items: [
            'Preguntas', 'Texto / Archivos'
            ],

            questions: [],
            isNote: false,
            isPercentage: false,
            isAverage: false,
            onlyNote: false,
            onlyPercentage: false,
            showAnswers: false
        };
    },
    components: {
        quillEditor
    },
    computed: {
        ...mapGetters({
            getResults: "getResults",
            getIsPreBasicAndLinkEmbebed: "getIsPreBasicAndLinkEmbebed",
            getCurrentAnswers: "getCurrentAnswers",
            answers: "getAnswers",
            getEvaluationDetail: "getEvaluationDetail",

            getCurrentTextFormaAsignada:"getCurrentTextFormaAsignada",
            getCurrentFilesFormaAsignada:"getCurrentFilesFormaAsignada",
            getCurrentTextAnswers:"getCurrentTextAnswers",
            getCurrentFilesAnswers:"getCurrentFilesAnswers"
        }),
        answers() {
            return this.getResults.answers;
        },
        corrects() {
            return this.getResults.correctas;
        },
        incorrects() {
            return this.getResults.incorrectas;
        },
        skippeds() {
            return this.getResults.omitidas;
        },
        points() {
            return this.getResults.puntajeEstandar;
        },
        percentage() {
            return this.getResults.porcentajePonderadologro;
        }
    },
    mounted() {
        switch (this.getResults.enviarNota) {
            case "ENVIAR_NOTA_LOGRO":
                this.isNote = true;
                this.isPercentage = true;
                break;
            case "ENVIAR_NOTA":
                this.isNote = true;
                this.onlyNote = true;
                break;
            case "ENVIAR_LOGRO":
                this.isPercentage = true;
                this.onlyPercentage = true;
                break;
        }
        this.showAnswers = this.getResults.mostrarRespuestas;
        const list = [];
        const optionLetters = ["A", "B", "C", "D", "E", "F"];
        this.answers.forEach(row => {
            if (row.letraRespuesta !== "") {
                if (row.letraRespuesta === row.letraRespuestaCorrecta) {
                    const options = [];
                    let correct = null;
                    let mode = null;
                    let styleClass = null;
                    for (let i = 0; i < row.nroAlternativas; i++) {
                        if (row.letraRespuesta === optionLetters[i]) {
                            correct = optionLetters[i];
                            mode = "correct";
                            if (!this.getIsPreBasicAndLinkEmbebed) {
                                styleClass = "correct";
                            }else{
                                styleClass = "correct"+optionLetters[i];
                            }
                        } else {
                            mode = "empty";
                            styleClass = "empty";
                        }
                        options.push({
                            letter: optionLetters[i],
                            correct: correct,
                            mode: mode,
                            class: styleClass
                        });
                    }
                    list.push({
                        nroPregunta: row.nroPregunta,
                        nroAlternativas: row.nroAlternativas,
                        mode: "CORRECT",
                        answered:
                            row.letraRespuesta !== ""
                                ? row.letraRespuesta
                                : null,
                        correct: row.letraRespuestaCorrecta,
                        class: "container-correct",
                        options: options
                    });
                } else {
                    const options = [];
                    let correct = null;
                    let incorrect = null;
                    let mode = null;
                    let styleClass = null;
                    for (let i = 0; i < row.nroAlternativas; i++) {
                        if (row.letraRespuestaCorrecta === optionLetters[i]) {
                            correct = optionLetters[i];
                            mode = "correct";
                            styleClass = "correct-inverted";
                        } else if (row.letraRespuesta === optionLetters[i]) {
                            incorrect = optionLetters[i];
                            mode = "incorrect";
                            if (!this.getIsPreBasicAndLinkEmbebed) {
                                styleClass = "incorrect";
                            }else{
                                styleClass = "incorrect"+optionLetters[i];
                            }
                        } else {
                            mode = "empty";
                            styleClass = "empty";
                        }
                        options.push({
                            letter: optionLetters[i],
                            correct: correct,
                            incorrect: incorrect,
                            mode: mode,
                            class: styleClass
                        });
                    }
                    list.push({
                        nroPregunta: row.nroPregunta,
                        nroAlternativas: row.nroAlternativas,
                        mode: "INCORRECT",
                        answered:
                            row.letraRespuesta !== ""
                                ? row.letraRespuesta
                                : null,
                        correct: row.letraRespuestaCorrecta,
                        class: "container-incorrect",
                        options: options
                    });
                }
            } else {
                const options = [];
                let correct = null;
                let mode = null;
                let styleClass = null;
                for (let i = 0; i < row.nroAlternativas; i++) {
                    if (row.letraRespuestaCorrecta === optionLetters[i]) {
                        correct = optionLetters[i];
                        mode = "skipped";
                        styleClass = "skipped";
                    } else {
                        mode = "empty";
                        styleClass = "empty";
                    }
                    options.push({
                        letter: optionLetters[i],
                        correct: correct,
                        mode: mode,
                        class: styleClass
                    });
                }
                list.push({
                    nroPregunta: row.nroPregunta,
                    nroAlternativas: row.nroAlternativas,
                    mode: "SKIPPED",
                    answered:
                        row.letraRespuesta !== "" ? row.letraRespuesta : null,
                    correct: row.letraRespuestaCorrecta,
                    class: "container-skipped",
                    options: options
                });
            }
        });
        this.questions = list;

        const { attachFiles ,enterText } = this.getEvaluationDetail.medicionAsignadaTO.medicionTO;
        this.attachFiles = attachFiles;
        this.enterText = enterText;
        if (enterText) {
            this.textRubrica = this.getCurrentTextFormaAsignada[3];
        }
        if (attachFiles) {
            for (let i = 0; i < this.getCurrentFilesFormaAsignada.length; i++) {
                const f = new File([""], this.getCurrentFilesFormaAsignada[i][4], { type: 'text/html' });
                this.files.push(f);
            }
        }

        this.getEvaluationDetail.form.questions.forEach(a => {
            this.questions.forEach(answer => {
                if (a.nroQuestion == answer.nroPregunta) {
                    answer.attachFiles =  a.attachFiles
                    answer.enterText = a.enterText
                };
            })
        });


        if (this.questions !== null && this.getCurrentAnswers !== null) {
            this.questions.forEach(answer => {
                answer['files'] = []
                if (this.getCurrentAnswers.length !== 0) {

                    this.getCurrentAnswers.forEach(currentAnswer => {
                        
                        if (
                            answer.nroPregunta === currentAnswer.nroPregunta
                        ) {
                            // answer.answerLetter = currentAnswer.letraRespuesta;

                            // RUBRICA
                            answer['text'] = currentAnswer.textoRespuesta;
                            if (currentAnswer.fileRespuesta && currentAnswer.fileRespuesta.length > 0) {
                                for (let i = 0; i < currentAnswer.fileRespuesta.length; i++) {
                                    answer.files.push(currentAnswer.fileRespuesta[i])
                                }
                            }
                            if (answer.enterText  || answer.attachFiles) {
                                
                                answer['class'] = "container-rubrica";

                            }

                        }
                    });
                // } else {
                //     answer.answerLetter = "";

                }
            });
            // this.setAnswers({ answers: this.answers });
        }
    },
    methods: {
        calculatePercentage(p) {
            const s = p.toString();
            const sp = s.split(".");
            if (sp.length >= 2) {
                return p.toFixed(1);
            }
            return p;
        }
    }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Cabin:wght@400;500;600;700&display=swap");
@import "../../assets/styles/numbers.css";
@import "../../assets/styles/letters.css";

.evaluation-quiz {
    padding: 0 !important;
}

.container-question {
    font-family: "Cabin", Regular, sans-serif !important;
    background: #ffffff 0 0 no-repeat padding-box;
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    opacity: 1;
    margin-bottom: 15px;
    height: auto;
    i,
    .v-icon {
        font-family: "Cabin", Regular, sans-serif !important;
        font-style: normal;
    }
}

.answered {
    border: 1px solid #3a8fce;
}

.border-normal {
    border: 1px solid #c4c4c4;
}

hr {
    border: 0.15px #dcdcdc solid !important;
}

.btn-question {
    width: 45px;
    height: 44px;
    max-width: 45px;
    border-radius: 5px 0 0 5px;
    font-size: 24px;
    font-weight: bold;
    opacity: 1;
    border-right: 1px solid #d7d7d7;
    margin-right: 20px;
    cursor: default !important;
}

.btn-answered {
    background: #3a8fce 0 0 no-repeat padding-box;
    color: #ffffff;
    cursor: default !important;
}

.answer {
    width: 36px;
    height: 36px;
    background: #ffffff 0 0 no-repeat padding-box;
    border: 1px solid #c1c1c1;
    border-radius: 5px;
    opacity: 1;
    margin: 4px 0;
    cursor: default !important;
}

.active {
    background: #f39444 0 0 no-repeat padding-box;
    color: #ffffff;
}

.inactive {
    background: transparent;
}

.note {
    .title {
        font-family: "Cabin Light", Regular, sans-serif !important;
        font-size: 2.2em;
        color: #393939;
    }
    .response {
        font-family: "Cabin Light", Regular, sans-serif !important;
        font-size: 2.25em;
        color: #3a8fce;
        font-weight: 300;
    }
}
.legend {
    font-family: "Cabin Light", Regular, sans-serif !important;
    font-size: 1em;
    color: #393939;
    span {
        margin-left: 5px;
    }
}
.icon-indicator {
    font-size: 18px;
    padding-left: 4px;
    font-weight: 500;
}
.incorrect {
    background: #ff5757;
    i {
        color: #ffffff;
    }
}
.correct {
    background: #3a8fce;
    i {
        color: #ffffff;
    }
}
.skipped {
    background: #c1c1c1;
    i {
        color: #ffffff;
    }
}

.correct-inverted {
    background: #ffffff;
    border: 1px solid #3a8fce;
    i {
        color: #3a8fce;
    }
}

.empty {
    background: transparent;
}

.container-correct {
    border: 1px solid #3a8fce;
    .btn-question {
        background: #3a8fce;
        i {
            font-weight: bold;
            color: #ffffff;
        }
    }
}
.container-incorrect {
    border: 1px solid #ff5757;
    .btn-question {
        background: #ff5757;
        i {
            font-weight: bold;
            color: #ffffff;
        }
    }
}
.container-skipped {
    border: 1px solid #c1c1c1;
    .btn-question {
        background: #c1c1c1;
        i {
            font-weight: bold;
            color: #ffffff;
        }
    }
}

.group-btn-zoom {
    position: fixed;
    top: 170px !important;
}

@media (min-width: 959px) {
    .group-btn-zoom {
        right: 40% !important;
        top: 150px;
    }
}

@media (min-width: 1259px) {
    .group-btn-zoom {
        right: 32% !important;
    }
}


.answerA{ 
    border: 3px solid #e00a18;
}
.answerB{
    border: 3px solid #3457f3;
}
.answerC{
    border: 3px solid #28d654;
}
.answerD{
    border: 3px solid #fcdf00;
}
.answerE{
    border: 3px solid #8712fc;
}

.incorrectA {
    background: #e00a18 0 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}
.incorrectB {
    background: #3457f3 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}
.incorrectC {
    background: #28d654 0 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}
.incorrectD {
    background: #fcdf00 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}
.incorrectD {
    background: #8712fc 0 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}


.correctA {
    background: #e00a18 0 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}
.correctB {
    background: #3457f3 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}
.correctC {
    background: #28d654 0 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}
.correctD {
    background: #fcdf00 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}
.correctE {
    background: #8712fc 0 0 no-repeat padding-box;
    i {
        color: #ffffff;
    }
}



.activeA {
    background: #e00a18 0 0 no-repeat padding-box;
}
.activeB {
    background: #3457f3 0 no-repeat padding-box;
}
.activeC {
    background: #28d654 0 0 no-repeat padding-box;
}
.activeD {
    background: #fcdf00 0 no-repeat padding-box;
}
.activeE {
    background: #8712fc 0 0 no-repeat padding-box;
}
</style>
